__turbopack_context__.v({
  "empty": "step-list-module__szKOwq__empty",
  "ingHighlight": "step-list-module__szKOwq__ingHighlight",
  "ingredientStrip": "step-list-module__szKOwq__ingredientStrip",
  "instruction": "step-list-module__szKOwq__instruction",
  "list": "step-list-module__szKOwq__list",
  "phase": "step-list-module__szKOwq__phase",
  "phases": "step-list-module__szKOwq__phases",
  "step": "step-list-module__szKOwq__step",
  "stepContent": "step-list-module__szKOwq__stepContent",
  "stepFadeUp": "step-list-module__szKOwq__stepFadeUp",
  "stepNumber": "step-list-module__szKOwq__stepNumber",
  "stepTitle": "step-list-module__szKOwq__stepTitle",
  "stripImage": "step-list-module__szKOwq__stripImage",
  "stripIngredient": "step-list-module__szKOwq__stripIngredient",
  "stripName": "step-list-module__szKOwq__stripName",
  "stripQty": "step-list-module__szKOwq__stripQty",
});
